import { render } from "./CopyFollowersPanelField.vue?vue&type=template&id=3679282e&scoped=true"
import script from "./CopyFollowersPanelField.vue?vue&type=script&lang=js"
export * from "./CopyFollowersPanelField.vue?vue&type=script&lang=js"

import "./CopyFollowersPanelField.vue?vue&type=style&index=0&id=3679282e&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3679282e"],['__file',"CopyFollowersPanelField.vue"]])

export default __exports__